import { getFigmaFileId } from "./getFigmaFileId";

const validUrls = ["figma.com/file", "figma.com/design", "figma.com/proto"];

export const validateFigmaFileURL = (value: string) => {
  const isValidUrl = validUrls.some(url => value.toLowerCase().includes(url));
  const fileId = getFigmaFileId(value);

  return isValidUrl && !!fileId;
};
